export default __webpack_public_path__ + "static/media/dropdown.8fe5d53f.svg";